import { ComplianceReportDownloadModel } from "./complianceReportDialog/ComplianceReportDialog.types";
import { useParams } from "react-router";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export default function useComplianceReportHooks() {
    const { id } = useParams<{ id: string }>();

    const url = `/complianceReportDownloads/${id}`;
    const { isLoading, data } = useDotLegalQuery<ComplianceReportDownloadModel>(url);

    return { isLoading, data };
}
